export enum EdoSettingEnum {
    THEME_PRIMARY_COLOR = 'THEME_PRIMARY_COLOR',
    THEME_SECONDARY_COLOR = 'THEME_SECONDARY_COLOR',
    CHAT_TEACHING_STAFF = 'CHAT_TEACHING_STAFF',
    STUDENT_POPUP_TIMEOUT = 'STUDENT_POPUP_TIMEOUT',
}
